











import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class LoadingModal extends Vue {
  @Prop({ default: false }) loading!: boolean
  @Prop({ default: 'Loading...' }) text!: string
  @Prop() processed!: number
  @Prop() totalProcess!: number

  get processedText() {
    return this.processed & this.totalProcess
      ? `${this.processed} / ${this.totalProcess}`
      : ''
  }
}
